<template lang="pug">
div
  b-row(v-show="isSubmitting")
    b-col
      b-card(class="py-5")
        loading(
          :active="true"
          :is-full-page="false"
          color="#498ceb"
        )
  ARIForm(
    v-show="!isSubmitting",
    :data="ariData",
    :on-save-draft="saveDraft",
    @submit="create"
  )
</template>

<script>
import ARIForm from '../shared/ARIForm.vue'
import useInherentRiskAdd from './useInherentRiskAdd'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  name: 'InherentRiskAdd',
  components: {
    ARIForm,
    Loading,
  },
  setup() {
    const { create, saveDraft, ariData, isSubmitting } = useInherentRiskAdd()

    return {
      create,
      saveDraft,
      ariData,
      isSubmitting,
    }
  },
}
</script>
